import { EMAIL_BATCH_MUTATION } from '../../../gql/mutations/flowcode'
import { EmailBatchRequestType } from '@app/code/src/types/flowcode.types'
import { gqlFetcher } from '@dtx-company/inter-app/src/services/gqlFetcher'

export const emailBatch = async (
  variables: EmailBatchRequestType
): Promise<{ emailBatch: { ok: boolean; batch: { id: string } } }> => {
  return gqlFetcher(EMAIL_BATCH_MUTATION, variables)
}
